import {clientIntl} from '../../../../../shared/scripts/ClientI18n'
import {ViewPopupLanguage} from '../../../../../shared/scripts/ui_popup/ViewPopupLanguage'
import {UIMMenuGameOrientationController} from './UIMMenuGameOrientationController'
import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables'
import {setElementInnerHTML, setElementOnClick} from '../../../../../shared/scripts/ui_utils/DomUtils'
import {uiManager} from '../../../EntryMobile'
import {StorageWrapper} from '../../../../../shared/scripts/StorageWrapper'
import {navigateToPage} from '../../../../../shared/scripts/ui_utils/ClientUtils'

enum MenuState {
    OPEN,
    CLOSED
}
export class UIMHeaderHamburgerController {
    private readonly hamburger: HTMLElement
    private readonly overlayScreen: HTMLElement
    private readonly menu: HTMLDivElement
    private readonly closeButton: HTMLElement
    private readonly rulebookButton: HTMLLinkElement
    private readonly changeLanguageButton: HTMLButtonElement

    private menuState: MenuState

    constructor() {
        this.menu = document.getElementById('m-mainpage-menu') as HTMLDivElement
        this.hamburger = document.getElementById('header-element-hamburger-container') as HTMLElement
        this.closeButton = document.getElementById('m-mainpage-menu-close') as HTMLElement
        this.overlayScreen = document.getElementById('m-mainpage-overlay') as HTMLElement
        this.rulebookButton = document.getElementById('m-mainpage-menu-link-rulebook') as HTMLLinkElement
        this.changeLanguageButton = document.getElementById('m-mainpage-language-selector') as HTMLButtonElement
        new UIMMenuGameOrientationController()

        setElementOnClick(this.rulebookButton, () => {
            const currentScene = uiManager.sceneController.scene
            StorageWrapper.setLastScene(currentScene)
            navigateToPage(`${clientIntl.getLanguagePathPrefix()}/catan-rules?style=mobile`, false, true)
        })

        this.setOpenAndCloseAction()
    }

    private setOpenAndCloseAction() {
        setElementOnClick(this.hamburger, () => this.setOpenAction())
        setElementOnClick(this.closeButton, () => this.setCloseAction())
        setElementOnClick(this.overlayScreen, () => this.setCloseAction())

        const languageDisplayName = clientIntl.getLanguageName(UIUtilsEjsVariables.language) as string
        setElementInnerHTML(this.changeLanguageButton, {key: 'strings:colonistCommon.utils.#buffer', options: {value: languageDisplayName}})
        setElementOnClick(this.changeLanguageButton, () => {
            this.setCloseAction()
            new ViewPopupLanguage()
        })
    }

    private setOpenAction() {
        if(this.menuState == MenuState.OPEN) return
        this.menu.classList.add('open')
        this.overlayScreen.classList.remove('hidden')
        this.menuState = MenuState.OPEN
    }

    setCloseAction() {
        if(this.menuState == MenuState.CLOSED) return
        this.menu.classList.remove('open')
        this.overlayScreen.classList.add('hidden')
        this.menuState = MenuState.CLOSED
    }

    hide() {
        this.menu.style.display = 'none'
    }

    show() {
        this.menu.style.display = ''
    }
}
